(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = (cents) => {
    const fmt = (window.theme && window.theme.moneyFormat) || 'R {{amount}}';
    const v = (cents / 100).toFixed(2);
    const withCommas = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/<[^>]*>/g, '');
  };
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* Mobile nav + search */
  $$('[data-menu-open]').forEach((b) => b.addEventListener('click', () => { $('#mobile-nav').classList.add('is-open'); document.body.style.overflow = 'hidden'; }));
  $$('[data-menu-close]').forEach((b) => b.addEventListener('click', () => { $('#mobile-nav').classList.remove('is-open'); document.body.style.overflow = ''; }));
  $$('[data-search-toggle]').forEach((b) => b.addEventListener('click', () => { const s = $('#search-bar'); s.classList.toggle('is-open'); if (s.classList.contains('is-open')) $('input', s).focus(); }));

  /* Toast */
  function toast(msg) {
    let t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('show'), 2500);
  }

  /* Cart drawer (Shopify AJAX Cart API) */
  const drawer = $('#cart-drawer');
  const openDrawer = () => { document.documentElement.classList.add('drawer-open'); refresh(); };
  const closeDrawer = () => document.documentElement.classList.remove('drawer-open');
  $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { if (!drawer) return; e.preventDefault(); openDrawer(); }));
  $$('[data-cart-close]').forEach((b) => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); const m = $('#mobile-nav'); m && m.classList.remove('is-open'); document.body.style.overflow = ''; } });

  function updateCount(n) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.hidden = n === 0; });
  }

  function render(cart) {
    updateCount(cart.item_count);
    if (!drawer) return;
    const body = $('[data-drawer-body]', drawer);
    const foot = $('[data-drawer-foot]', drawer);
    if (!cart.items.length) {
      body.innerHTML = '<div class="d-empty"><p>Your bag is empty.</p><a class="btn btn--outline" href="' + window.theme.routes.root + 'collections/all">Continue shopping</a></div>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map((i, idx) => `
      <div class="d-item" data-line="${idx + 1}">
        <a href="${i.url}">${i.image ? `<img src="${i.image}${i.image.includes('?') ? '&' : '?'}width=200" alt="${esc(i.product_title)}" loading="lazy">` : '<div class="placeholder" style="aspect-ratio:4/5"></div>'}</a>
        <div>
          <h4><a href="${i.url}">${esc(i.product_title)}</a></h4>
          ${i.variant_title && i.variant_title !== 'Default Title' ? `<div class="small">${esc(i.variant_title)}</div>` : ''}
          <div class="qty" style="margin-top:.6rem">
            <button type="button" aria-label="Decrease" data-q="${i.quantity - 1}">−</button>
            <input type="number" value="${i.quantity}" min="0" aria-label="Quantity" readonly>
            <button type="button" aria-label="Increase" data-q="${i.quantity + 1}">+</button>
          </div>
        </div>
        <div style="text-align:right">
          <div>${money(i.final_line_price)}</div>
          ${i.original_line_price > i.final_line_price ? `<s class="small">${money(i.original_line_price)}</s>` : ''}
          <div style="margin-top:.75rem"><button class="remove" type="button" data-q="0">Remove</button></div>
        </div>
      </div>`).join('');
    $('[data-drawer-subtotal]', drawer).textContent = money(cart.total_price);
  }

  async function refresh() {
    try { const r = await fetch(window.theme.routes.cart + '.js'); render(await r.json()); } catch (e) { console.error(e); }
  }

  async function change(line, quantity) {
    drawer && drawer.classList.add('is-loading');
    try {
      const r = await fetch(window.theme.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
      const cart = await r.json();
      if (!r.ok) { toast(cart.description || 'Could not update your bag'); await refresh(); } else render(cart);
    } finally { drawer && drawer.classList.remove('is-loading'); }
  }

  drawer && drawer.addEventListener('click', (e) => {
    const b = e.target.closest('[data-q]'); if (!b) return;
    const line = +b.closest('[data-line]').dataset.line;
    change(line, Math.max(0, +b.dataset.q));
  });

  /* Add to cart forms */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form.js-add, form[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();
    const btn = $('[type=submit]', form);
    const label = btn.innerHTML;
    btn.disabled = true; btn.textContent = 'Adding…';
    try {
      const r = await fetch(window.theme.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await r.json();
      if (!r.ok) { toast(data.description || data.message || 'Could not add to bag'); return; }
      toast('Added to your bag');
      if (drawer) openDrawer(); else refresh();
    } catch (err) { form.submit(); }
    finally { btn.disabled = false; btn.innerHTML = label; }
  });

  /* Product page: variants, gallery, quantity */
  $$('[data-product]').forEach((root) => {
    const dataEl = $('script[data-variants]', root);
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const idInput = $('input[name=id]', root);
    const priceEl = $('[data-price]', root);
    const stockEl = $('[data-stock]', root);
    const btn = $('[data-add-btn]', root);
    const mainImg = $('.js-main-image', root);

    function selected() { return $$('fieldset.option', root).map((f) => ($('input:checked', f) || {}).value); }
    function update() {
      const opts = selected();
      const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
      $$('fieldset.option', root).forEach((f, idx) => {
        $$('input', f).forEach((inp) => {
          const test = opts.slice(); test[idx] = inp.value;
          const match = variants.find((x) => x.options.every((o, i) => o === test[i]));
          inp.classList.toggle('unavailable', !match || !match.available);
        });
      });
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      priceEl.innerHTML = v.compare_at_price > v.price
        ? `<span>${money(v.price)}</span><s>${money(v.compare_at_price)}</s>` : `<span>${money(v.price)}</span>`;
      priceEl.classList.toggle('price--sale', v.compare_at_price > v.price);
      btn.disabled = !v.available; btn.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (stockEl) { stockEl.textContent = v.available ? 'In stock — ready to ship' : 'Currently sold out'; stockEl.classList.toggle('stock--out', !v.available); }
      if (v.featured_image && mainImg) { mainImg.src = v.featured_image + (v.featured_image.includes('?') ? '&' : '?') + 'width=1200'; mainImg.removeAttribute('srcset'); }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    }
    $$('fieldset.option input', root).forEach((i) => i.addEventListener('change', update));
    update();

    $$('[data-thumb]', root).forEach((t) => t.addEventListener('click', () => {
      mainImg.src = t.dataset.thumb; mainImg.removeAttribute('srcset');
      $$('[data-thumb]', root).forEach((x) => x.setAttribute('aria-current', x === t));
    }));
  });

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]'); if (!b) return;
    const input = b.parentElement.querySelector('input');
    input.value = Math.max(+input.min || 1, (+input.value || 1) + +b.dataset.qtyStep);
  });

  /* Collection sort */
  $$('[data-sort]').forEach((s) => s.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); location.href = u; }));

  refresh();
})();
